import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../SdsGlobalHeaderMobile/SdsGlobalHeaderMobile.vue.js';
import __vue_component__$1 from '../SdsIllustration/SdsIllustration.vue.js';
import __vue_component__$2 from '../content/CustomImage.vue.js';
import { getAssetsDomain } from '../assets/assetsDomain.js';

var script = defineComponent({
    name: 'SdsFeatureHeader',
    props: {
        title: {
            type: String,
            required: false,
            default: undefined,
        },
        subtitle: {
            type: String,
            required: false,
            default: undefined,
        },
        headerActionItems: {
            type: Array,
            required: false,
            default: function () { return []; },
        },
        illustrationName: {
            type: String,
            required: false,
            default: undefined,
        },
        brandIllustrationName: {
            type: String,
            required: false,
            default: undefined,
        },
        feature: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    emits: [
        'click:back',
        'click:rightSideIcon',
    ],
    setup: function () {
        return {
            assetsDomain: getAssetsDomain(),
        };
    },
    components: {
        SdsGlobalHeaderMobile: __vue_component__,
        SdsIllustration: __vue_component__$1,
        CustomImage: __vue_component__$2,
    },
});

export default script;
